<template>
	<el-menu
	  class="el-menu-vertical-demo"
	  :default-active="active_index"
	  @open="handleOpen"
	  @close="handleClose">
	  <!-- <el-submenu index="1">
		<template slot="title">
		  <i class="el-icon-location"></i>
		  <span>导航一</span>
		</template>
		<el-menu-item-group>
		  <template slot="title">分组一</template>
		  <el-menu-item index="1-1">选项1</el-menu-item>
		  <el-menu-item index="1-2">选项2</el-menu-item>
		</el-menu-item-group>
		<el-menu-item-group title="分组2">
		  <el-menu-item index="1-3">选项3</el-menu-item>
		</el-menu-item-group>
		<el-submenu index="1-4">
		  <template slot="title">选项4</template>
		  <el-menu-item index="1-4-1">选项1</el-menu-item>
		</el-submenu>
	  </el-submenu> -->
	  <el-menu-item index="100" @click="toUrl('user_uinfo')">
	  		<i class="el-icon-user-solid"></i>
	  		<span slot="title">我的信息</span>
	  </el-menu-item>
	  <el-menu-item index="110" @click="toUrl('user_collection')">
		<i class="el-icon-star-on"></i>
		<span slot="title">我的收藏</span>
	  </el-menu-item>
	  <el-menu-item index="120" @click="toUrl('user_payment')">
		<i class="el-icon-s-order"></i>
		<span slot="title">我的订单</span>
	  </el-menu-item>
	  <el-menu-item index="130" @click="toUrl('user_invoice')">
		<i class="el-icon-s-ticket"></i>
		<span slot="title">我的发票</span>
	  </el-menu-item>
	  <el-menu-item index="140" @click="toUrl('detail_article?id=3306')">
	  		<i class="el-icon-s-finance"></i>
	  		<span slot="title">充值交费</span>
	  </el-menu-item>
	  <el-menu-item index="140" @click="toUrl('user_myxxxall')">
	  		<i class="el-icon-s-grid"></i>
	  		<span slot="title">我的画像</span>
	  </el-menu-item>
	</el-menu>
</template>

<script>
	export default {
		data() {
			return {
				active_index: '0',
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				
				// 本想更改左侧菜单样式，但未生效
				if (to.name.indexOf('uinfo') > -1) {
					this.active_index = '100'
				}else if (to.name.indexOf('collection') > -1) {
					this.active_index = '110'
				} else if (to.name.indexOf('payment') > -1) {
					this.active_index = '120'
				} else if (to.name.indexOf('invoice') > -1) {
					this.active_index = '130'
				} 
				
				next()
			})
		},
		
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			
			
		}
	}
</script>

<style scoped>
	.el-menu {
		min-height: 500px;
	}
</style>